<template>
  <div>
    <div class="bg-gray-200 mt-2 pb-2"
         v-for='animation in animations'
         :key='animation.id'>

      <input class="w-full bg-gray-200 text-gray-600 border border-gray-200 rounded py-2 px-1 mb-2 text-center" 
              v-model="animation.name" />
      <div class="h-24 flex flex-row grow rounded p-2 flex-no-wrap overflow-scroll">
          <pbc-button v-for='(frame,i) in animation.frames'
                      @click='editFrame(frame,i)'
                      class='relative'
                      :key='frame.sprite'>
            <sprite-view class='h-16 w-16'
                        :sprite='frame' />

            <pbc-button v-if='i > 0'
                        class="absolute top-0 right-0 bg-red-400 ml-1 mt-1"
                        @click='removeFrame(animation, i)'>
              <close :size='12' />
            </pbc-button>

          </pbc-button>
          <pbc-button class="h-20 text-blue-900" @click='addFrame(animation)'>
            <plus-circle :size='32'/>
          </pbc-button>

      </div>
      <div class="w-full my-1 h-12 flex flex-row justify-center px-2">
          <div class="w-24">
            <span class="text-xs text-gray-600">Speed</span>
            <numberer class="w-full" v-model='animation.timePerFrame' />
          </div>
          <div>
            <span class="text-xs text-gray-600">Loop</span>
            <input type="checkbox" class="w-full" v-model='animation.loopByDefault' />
          </div>
          <pbc-button v-if='animation.id !== "default"' class="bg-red-400 ml-2 mt-2" @click='removeAnimation(animation)'>
            <close :size='32' />
          </pbc-button>
      </div>

    </div>

    <pbc-button class="mt-8" @click='addAnimation'>
      <plus-circle :size='24'/> Add Animation
    </pbc-button>

    <pbc-modal v-if='editingFrame.sprite'
               title=''
               @done='editingFrame = {}'
               @close='editingFrame = {}'>
      <template #default='{}'>
        <choose-or-upload-image game-id='chezzer'
                                @select='onSelect' />
      </template>
      <template #controls='{done}'>
      </template>
    </pbc-modal>
  </div>
</template>
<script>
import uuid from 'uuid';
import ChooseOrUploadImage from '@ui/organisms/ChooseOrUploadImage.vue';
import SpriteView from '@edit/atoms/SpriteView.vue';
import PlusCircle from '@icons/PlusCircle.vue';
import { toPairs } from 'lodash';
import Close from '@icons/Close.vue';
export default {
  props: {
    component: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      editingFrame:{},
      editingFrameIndex:0
    }
  },
  components: {
    SpriteView,
    ChooseOrUploadImage,
    PlusCircle,
    Close
  },
  methods: {
    editFrame(frame,i) {
      console.log('frame', frame);
      this.editingFrame = frame;
      this.editingFrameIndex = i;
    },
    onSelect({id,...rest}) {
      if (rest.spritesheet) {
        this.$set(this.editingFrame, 'atlas', rest.spritesheet);
        this.$set(this.editingFrame, 'texture', rest.image.name);
        this.$set(this.editingFrame, 'sprite', rest.image.name);

        if (this.editingFrameIndex === 0) {
          this.$set(this.component, 'atlas', rest.spritesheet);
          this.$set(this.component, 'texture', rest.image.name);
          this.$set(this.component, 'sprite', rest.image.name);
        }

      } else {
        this.$set(this.editingFrame, 'atlas', undefined);
        this.$set(this.editingFrame, 'texture', undefined);
        this.$set(this.editingFrame, 'sprite', id);

        if (this.editingFrameIndex === 0) {
          this.$set(this.component, 'sprite', id)
        }
      }
    },
    addFrame(animation) {
      const newFrame = {
        sprite:'placeholder.png',
      }
      animation.frames.push(newFrame);
      this.editingFrame = newFrame;
      this.editingFrameIndex = animation.frames.length-1;
    },
    addAnimation() {
      this.component.anims.push({
        id:uuid.v4(),
        name:'New Animation',
        frames:[
        ],
        timePerFrame: 1,
        loopByDefault: false
      });
    },
    removeAnimation(animation) {
      this.component.anims = this.component.anims.filter( ({id}) => {
        return id !== animation.id;
      });
    },
    removeFrame(animation, i) {
      animation.frames.splice(i, 1);
    }
  },
  mounted() {
    if (typeof(this.component.anims) === 'undefined') {
      this.$set(this.component, 'anims', [
        {
          id:'default',
          name:'Default',
          frames: [{
            atlas:this.component.atlas,
            sprite:this.component.sprite,
            texture:this.component.texture
          }],
          timePerFrame: 1,
          loopByDefault: true
        }
      ]);
    }
  },
  computed: {
    animations() {
      return this.component.anims;
    }
  }
}
</script>
